(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbr-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.carouselReady === 'true') return;
      root.dataset.carouselReady = 'true';
      const slides = [...root.querySelectorAll('[data-carousel-slide]')];
      const dots = [...root.querySelectorAll('[data-carousel-dot]')];
      if (slides.length < 2) return;
      const toggle = root.querySelector('[data-carousel-toggle]');
      let current = 0;
      let timer;
      let paused = false;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, i) => {
          const active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (root.dataset.autoplay === 'true' && !reduced && !paused) {
          timer = setInterval(() => show(current + 1), Number(root.dataset.speed) || 6000);
        }
      };
      const setPaused = (nextPaused) => {
        paused = nextPaused;
        if (!toggle) return;
        toggle.textContent = paused ? 'Play slideshow' : 'Pause slideshow';
        toggle.setAttribute('aria-label', toggle.textContent);
        if (paused) stop(); else start();
      };
      root.querySelector('[data-carousel-previous]')?.addEventListener('click', () => { show(current - 1); start(); });
      root.querySelector('[data-carousel-next]')?.addEventListener('click', () => { show(current + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.carouselDot)); start(); }));
      toggle?.addEventListener('click', () => setPaused(!paused));
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') show(current - 1);
        if (event.key === 'ArrowRight') show(current + 1);
      });
      document.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { show(index); stop(); }
      });
      show(0);
      start();
    };
    document.querySelectorAll('[data-tbr-carousel]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-tbr-carousel]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();
})();
